import { useCallback, useMemo, useState } from 'react';
import hand from '~/assets/icons/hand.svg';
import { playSound, Sound } from '~/assets/sounds';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { TextInput } from '~/components/ui/TextInput';
import { rage } from '~/rage';
import {
	setMenuTabsDisabled,
	setQuestTabActiveMenuItem,
	setTabIndex,
	useLayoutDispatch,
} from '../../redux';
import { QuestMenu } from '../QuestTab';
import { promocodeError, promocodeSuccess } from './Promocode.model';
import {
	StyledBottomContainer,
	StyledContainer,
	StyledInputContainer,
	StyledTopContainer,
} from './Promocode.styled';

const Promocode = () => {
	const dispatch = useLayoutDispatch();
	const [promocode, setPromocode] = useState('');
	const [isActivated, setIsActivated] = useState(false);
	const [error, setError] = useState(false);

	const statusText = useMemo(() => {
		if (error) {
			return promocodeError;
		}

		if (!isActivated) {
			return '';
		}

		return promocodeSuccess;
	}, [isActivated, error]);

	const handleClick = useCallback(async () => {
		if (!promocode) {
			return;
		}

		try {
			await rage.promo.activateCode(promocode);
		} catch (err) {
			setError(true);
			return;
		}

		setError(false);
		setIsActivated(true);
		setPromocode('');
		dispatch(setTabIndex(3));
		dispatch(setQuestTabActiveMenuItem(QuestMenu.Promo));
	}, [promocode]);

	return (
		<StyledContainer>
			<StyledTopContainer>
				<Text style={{ fontWeight: 500 }}>Промокод</Text>
				<Text style={{ fontWeight: 400, opacity: 0.5 }}>
					Если у вас появился промокод, то вы сможете его активировать в этом
					окне, введя его в поле ниже!
				</Text>
			</StyledTopContainer>
			<StyledBottomContainer>
				<Text className={error ? 'red' : 'green'}>{statusText}</Text>
				<StyledInputContainer>
					<TextInput
						height={40}
						fontSize={14}
						value={promocode}
						onChange={(e) => setPromocode(e.target.value)}
						onFocus={() => dispatch(setMenuTabsDisabled(true))}
						onBlur={() => dispatch(setMenuTabsDisabled(false))}
						placeholder={'Введите промокод'}
						active={!!promocode}
						tabIndex={-1}
						onMouseEnter={() => playSound(Sound.LinkCursor)}
					/>
					<Button
						color={ButtonColors.Select2}
						height={ButtonHeight.Height40}
						onClick={() => {
							handleClick();
							playSound(Sound.ClickButton);
						}}
						disabled={!promocode}
						square
					>
						<img src={hand} width={16} height={16} />
					</Button>
				</StyledInputContainer>
			</StyledBottomContainer>
		</StyledContainer>
	);
};

export { Promocode };
